
import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';
class EhgsBasvuruAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "EhgtBasvurusave";
    super(baseUrl);
  }


  saveEhgsBasvuruSave(request: EhgtBasvuruSaveRequest){
    
    return this.post("", request, true);
   
  }

}
export default new EhgsBasvuruAPI();
class EhgtBasvuruSaveRequest {
    basvuruTuruId: number;
    sicilKodu: number;
    beyanYili: number;
    beyanAyi: number;
    butceGelirId?: number | null;
    faaliyetKodu?: number | null;
    mahalleKodu: number;
    caddeSokakKodu: number;
    kapiNo: number;
    altKapiNo?: string | null;
    daireNo?: number | null;
    altDaireNo?: string | null;
    satisBedeli?: number | null;
    vergiTabiOlmynSatisBedel?: number | null;
    donemIadeTutari?: number | null;
    aciklama?: string | null;
    captchaToken?: string;

    constructor(
        basvuruTuruId: number,
        sicilKodu: number,
        beyanYili: number,
        beyanAyi: number,
        mahalleKodu: number,
        caddeSokakKodu: number,
        kapiNo: number,
        butceGelirId?: number | null,
        faaliyetKodu?: number | null,
        altKapiNo?: string | null,
        daireNo?: number | null,
        altDaireNo?: string | null,
        satisBedeli?: number | null,
        vergiTabiOlmynSatisBedel?: number | null,
        donemIadeTutari?: number | null,
        aciklama?: string | null,
        captchaToken?: string
    ) {
        this.basvuruTuruId = basvuruTuruId;
        this.sicilKodu = sicilKodu;
        this.beyanYili = beyanYili;
        this.beyanAyi = beyanAyi;
        this.mahalleKodu = mahalleKodu;
        this.caddeSokakKodu = caddeSokakKodu;
        this.kapiNo = kapiNo;
        this.butceGelirId = butceGelirId ?? null;
        this.faaliyetKodu = faaliyetKodu ?? null;
        this.altKapiNo = altKapiNo ?? null;
        this.daireNo = daireNo ?? null;
        this.altDaireNo = altDaireNo ?? null;
        this.satisBedeli = satisBedeli ?? null;
        this.vergiTabiOlmynSatisBedel = vergiTabiOlmynSatisBedel ?? null;
        this.donemIadeTutari = donemIadeTutari ?? null;
        this.aciklama = aciklama ?? null;
        this.captchaToken = captchaToken;
    }
}
export { EhgtBasvuruSaveRequest };